import React, { useContext, useState } from "react";
import "./ConfirmPopup.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect } from "react";
import STcontext from "../../context/STcontext";

const ConfirmDeleteTask = ({ message, id, deleteFunction, children }) => {
  const { task } = useContext(STcontext);
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  useEffect(() => {
    handleClose();
  }, [task]);
  return (
    <>
     
       <div onClick={handleShow}>{children}</div>
      <Modal
        show={modalShow}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={(e) => deleteFunction(id)}>
            delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmDeleteTask;
